// extracted by mini-css-extract-plugin
export default {"table":"v_62_WR2"};